<template>
  <div>
    <!-- <ceshi /> -->
    <Head :active="'home'" />
    <floatright />
    <banner />
    <introduction />
    <cont />
    <center />
    <new />
    <join />
    <cooperative />
    <inner />
    <Footer />
  </div>
</template>

<script>
import Head from '../../components/header.vue'
import Floatright from '../../components/floatright.vue'
import Banner from '../../components/banner.vue'
import Center from '../../components/center.vue'
import Cont from '../../components/cont.vue'
import New from '../../components/new.vue'
import Join from '../../components/join.vue'
import Inner from '../../components/inner.vue'
import Footer from '../../components/footer.vue'
import Ceshi from '../ceshi/ceshi.vue'
import Introduction from '../../components/introduction.vue'
import Cooperative from '../../components/cooperative.vue'
export default {
  components: {
    Ceshi,
    Head,
    Floatright,
    Banner,
    Cont,
    Center,
    New,
    Join,
    Inner,
    Footer,
    Introduction,
    Cooperative
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index/index-hbcj.vue